<template>
  <div class="booking-format-address">
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.consignorCode')">
      <special-character-tip :texts="specialCharCheck.shipperShortCode">
        <cargo-input v-model="manifestInfo.shipperShortCode" :class="importDifferenceField.shipperShortCode ? 'red-border' : ''" :placeholder="(isSeaHouseChannel || isWseChannel || isRongeTong) && isEditing ? $t('CargoMsg.Cargo_pleaseEnterTheEnterpriseCode') : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" label="+" class="label-right">
      <special-character-tip :texts="specialCharCheck.shipperEnterpriseCode">
        <cargo-input v-model="manifestInfo.shipperEnterpriseCode" :class="importDifferenceField.shipperEnterpriseCode ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item ref="shipperEnterpriseName" :class="labelStyle" :label="$t('SeaExport.consignorName')" prop="shipperEnterpriseName" :rules="[{ validator: validatorShipperEnterpriseName, trigger: 'blur', required: true}]">
      <el-tooltip :content="(isSeaHouseChannel || isWseChannel || isRongeTong) ?$t('CargoMsg.Cargo_ShipperEnterpriseNameTip2'):''" placement="bottom" effect="light">
        <special-character-tip :texts="specialCharCheck.shipperEnterpriseName">
          <cargo-input v-if="!showCombinedManifest" v-model="manifestInfo.shipperEnterpriseName" :class="importDifferenceField.shipperEnterpriseName ? 'red-border' : ''" :placeholder="addressTip" :auto-uppercase="true" :auto-half-word="true" :trim="(isSeaHouseChannel || isWseChannel || isRongeTong)" />
          <cargo-rich-textarea
            v-else
            v-model="manifestInfo.shipperEnterpriseName"
            no="shipperEnterpriseName"
            :text-chars="0"
            :warning-count="-1"
            wrap-symbol="n"
            auto-half-word
            auto-uppercase
            style="height: 70px;min-height: 70px ; width: 180px"
            :disabled="!isEditing"
            :class="importDifferenceField.shipperEnterpriseName ? 'red-border' : ''"
            :is-trim="(isSeaHouseChannel || isWseChannel || isRongeTong)"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.consignorName'),manifestInfo.shipperEnterpriseName,val=>{manifestInfo.shipperEnterpriseName=val})"
          />
        </special-character-tip>
      </el-tooltip>
    </el-form-item>
    <el-form-item ref="shipperAddress" :class="labelStyle" :label="$t('SeaExport.consignorDetailAddress')" prop="shipperAddress" :rules="[{ validator: validatorShipperAddress, trigger: 'blur', required: true}]">
      <special-character-tip :texts="specialCharCheck.shipperAddress">
        <cargo-input v-if="!showCombinedManifest" v-model="manifestInfo.shipperAddress" :class="importDifferenceField.shipperAddress ? 'red-border' : ''" :placeholder="addressTip2" :auto-uppercase="true" :auto-half-word="true" :trim="(isSeaHouseChannel || isWseChannel || isRongeTong)" />
        <cargo-rich-textarea
          v-else
          ref="cargoTextarea1"
          v-model="manifestInfo.shipperAddress"
          no="shipperAddress"
          :text-chars="0"
          :warning-count="-1"
          wrap-symbol="n"
          auto-half-word
          auto-uppercase
          style="height: 110px;width: 180px"
          :disabled="!isEditing"
          :class="importDifferenceField.shipperAddress ? 'red-border' : ''"
          :is-trim="(isSeaHouseChannel || isWseChannel || isRongeTong)"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.consignorDetailAddress'),manifestInfo.shipperAddress,val=>{manifestInfo.shipperAddress=val})"
        />
      </special-character-tip>
    </el-form-item>
    <el-form-item :class="manifestInfo.shipperContactsType === 0 ? labelStyle : 'mag'" label-width="0" class="auto-width" style="display: inline-block;">
      <div style="display: flex;">
        <el-select v-model="manifestInfo.shipperContactsType" :class="importDifferenceField.shipperContactsType ? 'require-select red-border' : 'require-select'" style="width:146px" @change="changeContactsType">
          <el-option :label="$t('SeaExport.consignorPhone')" :value="0" />
          <el-option :label="$t('SeaExport.consignorEmail')" :value="1" />
          <el-option :label="$t('SeaExport.consignorRelexNumber')" :value="2" />
        </el-select>
      </div>
    </el-form-item>
    <el-form-item ref="notifyPhone" :class="manifestInfo.shipperContactsType === 0 ? labelStyle : 'mag'" label-width="0" class="auto-width" prop="shipperContacts" :rules="[{ validator: validatorShipperPhone, trigger: 'blur' }]" style="display: inline-block;">
      <special-character-tip :texts="specialCharCheck.shipperContacts">
        <el-tooltip :content="manifestInfo.shipperContactsType === 0 ?$t('CargoMsg.Cargo_pleaseEnterAPhoneNumber'):''" placement="bottom" effect="light">
          <cargo-input
            v-model="manifestInfo.shipperContacts"
            :auto-uppercase="true"
            :auto-half-word="true"
            style="width:174px;margin-left:4px;"
            :class="importDifferenceField.shipperContacts ? 'red-border' : ''"
            :placeholder="manifestInfo.shipperContactsType === 0 && (isSeaHouseChannel || isWseChannel || isRongeTong) && isEditing ? $t('CargoMsg.Cargo_pleaseEnterAPhoneNumber') : ''"
          />
        </el-tooltip>
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="!(isWseChannel && manifestInfo.portOfLoading === 'CNTAO' && manifestInfo.thirdPartyCarrier === 'OOCL') && (!isSeaHouseChannel && !isWseChannel && !isRongeTong) " :label="$t('SeaExport.cityName')">
      <special-character-tip :texts="specialCharCheck.shipperCityName">
        <cargo-input v-model="manifestInfo.shipperCityName" :class="importDifferenceField.shipperCityName ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.provinceCode')">
      <special-character-tip :texts="specialCharCheck.shipperProvinceCode">
        <cargo-input v-model="manifestInfo.shipperProvinceCode" :class="importDifferenceField.shipperProvinceCode ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.provinceName')">
      <special-character-tip :texts="specialCharCheck.shipperProvinceName">
        <cargo-input v-model="manifestInfo.shipperProvinceName" :class="importDifferenceField.shipperProvinceName ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.ZipCode')">
      <special-character-tip :texts="specialCharCheck.shipperZipCode">
        <cargo-input v-model="manifestInfo.shipperZipCode" :class="importDifferenceField.shipperZipCode ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item ref="shipperCountryCode" :class="labelStyle" :label="$t('CargoMsg.Cargo_CountryRegionCode')" prop="shipperCountryCode" :rules="[{ validator: validatorShipperCountryCode, trigger: 'change' }]">
      <el-tooltip :content="$t('CargoMsg.Cargo_pleaseSelectACountryCode')" placement="bottom" effect="light">
        <special-character-tip :texts="specialCharCheck.shipperCountryCode">
          <cargo-input v-if="!isSeaHouseChannel && !isWseChannel && !isRongeTong" v-model="manifestInfo.shipperCountryCode" :class="importDifferenceField.shipperCountryCode ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
          <cargo-advance-select
            v-else
            :static-options="countryList || []"
            :cache="false"
            :default-value="manifestInfo.shipperCountryCode"
            filterable
            clearable
            :filter-tag-names="['name', 'code', 'chineseName']"
            :custom-label="(item)=>`[${item.code}]${item.name}`"
            tag-name="name"
            tag-value="code"
            :class="importDifferenceField.shipperCountryCode ? 'red-border' : ''"
            :placeholder="$t('CargoMsg.Cargo_pleaseSelectACountryCode')"
            @parentCallBack="p=>{manifestInfo.shipperCountryCode=p.value}"
          />
        </special-character-tip>
      </el-tooltip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.aeoEnterpriseCode')">
      <special-character-tip :texts="specialCharCheck.shipperAeoEnterpriseCode">
        <cargo-input v-model="manifestInfo.shipperAeoEnterpriseCode" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="isWseChannel && manifestInfo.portOfLoading === 'CNTAO' && manifestInfo.thirdPartyCarrier === 'OOCL'" class="required-label" prop="shipperCityName" :rules="[{ validator: validatorShipperCityName, trigger: 'blur' }]" :label="$t('SeaExport.consignorCityName')">
      <el-tooltip :content="$t('SeaExport.ShipperCityCannotBeBlank')" placement="bottom" effect="light">
        <special-character-tip :texts="specialCharCheck.shipperCityName">
          <cargo-input v-model="manifestInfo.shipperCityName" :placeholder="((isWseChannel && isEditing) ? $t('SeaExport.ShipperCityCannotBeBlank') : '')" :auto-uppercase="true" :auto-half-word="true" />
        </special-character-tip>
      </el-tooltip>
    </el-form-item>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :disabled="!isEditing"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <button
          v-show="isEditing"
          class="el-button el-button--default el-button--mini"
          no="advanceTextDialogConfirm"
          type="button"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</button>
        <button
          type="button"
          class="el-button el-button--default el-button--mini"
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoInput from '@/components/Cargo/Common/cargoInput'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip'
import StrUtils from '@/utils/StrUtils'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea.vue'

export default {
  name: 'BookingShipperFormatAddress',
  components: { cargoRichTextarea, CargoAdvanceSelect, cargoInput, specialCharacterTip },
  props: {
    manifestInfo: { type: Object, required: true },
    isSeaHouseChannel: { type: Boolean, default: false },
    isWseChannel: { type: Boolean, default: false },
    isRongeTong: { type: Boolean, default: false },
    isEditing: { type: Boolean, default: false },
    specialCharacterCheck: { type: Boolean, default: false },
    countryList: { type: Array, default: () => [] },
    job: { type: Object, default: () => {} },
    showCombinedManifest: { type: Boolean, default: false }
  },
  data() {
    var validatorShipperEnterpriseName = (rule, value, callback) => {
      if (this.isWseChannel || this.isSeaHouseChannel || this.isRongeTong) {
        if (!(this.manifestInfo.shipperEnterpriseName.length > 0 && this.manifestInfo.shipperEnterpriseName.length <= 70)) {
          return callback(new Error(this.$t('CargoMsg.Cargo_ShipperEnterpriseNameTip2')))
        }
      }
    }
    var validatorShipperAddress = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!(this.manifestInfo.shipperAddress.length > 0 && this.manifestInfo.shipperAddress.length <= 140)) {
          return callback(new Error(this.$t('CargoMsg.Cargo_ShipperEnterpriseNameTip')))
        }
      }
    }
    var validatorShipperPhone = (rule, value, callback) => {
      if (this.isSeaHouseChannel && this.manifestInfo.shipperContactsType === 0) {
        if (!this.manifestInfo.shipperContacts.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_ShipperContactsTip')))
        }
      }
      if ((this.isWseChannel || this.isRongeTong) && this.manifestInfo.shipperContactsType === 0) {
        if (!(this.manifestInfo.shipperContacts.length > 0 && this.manifestInfo.shipperContacts.length <= 20)) {
          return callback(new Error(this.$t('CargoMsg.Cargo_ShipperContactsTip')))
        }
      }
      return callback()
    }
    var validatorShipperCountryCode = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!this.manifestInfo.shipperCountryCode.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_pleaseSelectACountryCode')))
        }
      }
    }
    var validatorShipperCityName = (rule, value, callback) => {
      if (this.isWseChannel || this.isRongeTong) {
        if (!this.manifestInfo.shipperCityName.length > 0) {
          return callback(new Error(this.$t('SeaExport.ShipperCityCannotBeBlank')))
        }
      }
    }
    return {
      validatorShipperEnterpriseName,
      validatorShipperAddress,
      validatorShipperPhone,
      validatorShipperCountryCode,
      validatorShipperCityName,
      specialCharCheck: {
        shipperShortCode: null,
        shipperEnterpriseCode: null,
        shipperEnterpriseName: null,
        shipperAddress: null,
        shipperContacts: null,
        shipperCityName: null,
        shipperProvinceCode: null,
        shipperProvinceName: null,
        shipperZipCode: null,
        shipperCountryCode: null,
        shipperAeoEnterpriseCode: null
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      }
    }
  },
  computed: {
    labelStyle() {
      return (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) ? 'required-label' : ''
    },
    notSeaHouseChannelOrWseChannel() {
      return !(this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong)
    },
    addressTip() {
      if ((this.isWseChannel || this.isSeaHouseChannel || this.isRongeTong) && this.isEditing) {
        return this.$t('CargoMsg.Cargo_pleaseEnterANameWithin140Characters2')
      }
      return ''
    },
    addressTip2() {
      if ((this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) && this.isEditing) {
        return this.$t('CargoMsg.Cargo_pleaseEnterANameWithin140Characters')
      }
      return ''
    },
    importDifferenceField() {
      if (this.job) {
        return this.job.differencePrePlanFields || {}
      }
      return {}
    }
  },
  watch: {
    manifestInfo: {
      immediate: true,
      handler() {
        if (this.specialCharacterCheck) {
          for (const key in this.specialCharCheck) {
            this.specialCharCheck[key] = StrUtils.getSpecialTexts(this.manifestInfo[key])
          }
        } else {
          for (const key in this.specialCharCheck) {
            this.specialCharCheck[key] = null
          }
        }
      }
    },
    isSeaHouseChannel() {
      this.validate()
    },
    isWseChannel() {
      this.validate()
    },
    isRongeTong() {
      this.validate()
    }
  },
  methods: {
    changeContactsType() {
      this.$refs['notifyPhone'].clearValidate()
    },
    validate() {
      this.$refs['shipperEnterpriseName'].clearValidate()
      this.$refs['shipperAddress'].clearValidate()
      this.$refs['notifyPhone'].clearValidate()
      this.$refs['shipperCountryCode'].clearValidate()
    },
    checkModel(tabName) {
      if (!this.manifestInfo.shipperCityName && this.isWseChannel && this.manifestInfo.thirdPartyCarrier === 'OOCL' && this.manifestInfo.portOfLoading === 'CNTAO') {
        throw new TabError(this.$t('SeaExport.ShipperCityCannotBeBlank'), tabName)
      }
    },
    changeAll() {
      this.$refs.shipperEnterpriseName.validate((a) => {
      })
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    closeAdvanceText() {
      this.advanceTextDialog.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .booking-format-address{
    /deep/ .required-label {
      .el-form-item__label {
        color: #1F75D5 !important;
      }
      .require-select input{
        color: #1F75D5 !important;
      }
    }
    /deep/ .el-form-item.required-label {
      margin-bottom: 20px !important; /* 设置上下间距 */
    }
    /deep/ .el-form-item.mag {
      margin-bottom: 20px !important; /* 设置上下间距 */
    }
  }
  .red-border {
    /deep/ .el-input__inner,
    /deep/ .el-textarea__inner {
      border: 1px solid red !important;
    }
  }
</style>
